import React from 'react'

const SubmenuWay: React.FC = (): JSX.Element => {
	return (
		<svg
			viewBox="0 0 1929 360"
			className="absolute z-1"
			style={{ zIndex: 1 }}>
			<defs>
				<style>
					{
						'.a-way-submenu{fill:none;}.b-way-submenu{fill:#001f5f;}.c-way-submenu{clip-path:url(#a-way-submenu);}.d-way-submenu,.h-way-submenu,.n-way-submenu{fill:#fff;}.e-way-submenu{fill:#e7002a;}.f-way-submenu{fill:url(#b-way-submenu);}.g-way-submenu{opacity:0.8;}.g-way-submenu,.o-way-submenu{mix-blend-mode:multiply;isolation:isolate;}.g-way-submenu,.m-way-submenu{fill:url(#c-way-submenu);}.h-way-submenu{font-size:24px;}.h-way-submenu,.n-way-submenu{font-family:"Kiona-Bold";font-weight:700;}.i-way-submenu{fill:url(#d-way-submenu);}.j-way-submenu{fill:url(#f-way-submenu);}.k-way-submenu{fill:url(#h-way-submenu);}.l-way-submenu{fill:url(#j-way-submenu);}.m-way-submenu{opacity:0.75;}.n-way-submenu{font-size:42px;}.o-way-submenu{filter:url(#n-way-submenu);}.p-way-submenu{filter:url(#k-way-submenu);}'
					}
				</style>
				<clipPath id="a-way-submenu">
					<rect
						className="a-way-submenu"
						width={1427.387}
						height={206.155}
					/>
				</clipPath>
				<pattern
					id="b-way-submenu"
					width={1}
					height={1}
					viewBox="0 3.772 337.945 173.187">
					<image
						preserveAspectRatio="xMidYMid slice"
						width={386.312}
						height={257.394}
						xlinkHref="/images/navbar/trayectoria-1.jpg"
					/>
				</pattern>
				<linearGradient
					id="c-way-submenu"
					x1={0.5}
					x2={0.5}
					y2={1}
					gradientUnits="objectBoundingBox">
					<stop offset={0} stopColor="#001f5f" stopOpacity={0} />
					<stop offset={1} stopColor="#001f5f" />
				</linearGradient>
				<pattern
					id="d-way-submenu"
					width={1}
					height={1}
					viewBox="3.46 10.305 379.393 194.427">
					<image
						preserveAspectRatio="xMidYMid slice"
						width={386.313}
						height={257.542}
						xlinkHref="/images/navbar/trayectoria-2.jpg"
					/>
				</pattern>
				<pattern
					id="f-way-submenu"
					width={1}
					height={1}
					viewBox="7.768 4.512 365.712 187.416">
					<image
						preserveAspectRatio="xMidYMid slice"
						width={386.313}
						height={257.52}
						xlinkHref="/images/navbar/trayectoria-3.jpg"
					/>
				</pattern>
				<pattern
					id="h-way-submenu"
					preserveAspectRatio="xMidYMid slice"
					width="100%"
					height="100%"
					viewBox="0 0 8688 5792">
					<image
						width={8688}
						height={5792}
						xlinkHref="/images/navbar/trayectoria-4.jpg"
					/>
				</pattern>
				<pattern
					id="j-way-submenu"
					width={1}
					height={1}
					patternTransform="matrix(-1, 0, 0, 1, 1159.222, 0)"
					viewBox="0 30.021 517.611 295.735">
					<image
						preserveAspectRatio="xMidYMid slice"
						width={579.611}
						height={386.441}
						xlinkHref="/images/navbar/trayectoria-5.jpg"
					/>
				</pattern>
				<filter
					id="k-way-submenu"
					x={0}
					y={0}
					width={597.611}
					height={349.159}
					filterUnits="userSpaceOnUse">
					<feOffset dy={3} />
					<feGaussianBlur stdDeviation={3} result="l" />
					<feFlood floodOpacity={0.502} />
					<feComposite operator="in" in2="l" />
					<feComposite in="SourceGraphic" />
				</filter>
				<filter
					id="n-way-submenu"
					x={0}
					y={0}
					width={597.611}
					height={349.159}
					filterUnits="userSpaceOnUse">
					<feOffset dy={3} />
					<feGaussianBlur stdDeviation={3} result="o" />
					<feFlood floodOpacity={0.502} />
					<feComposite operator="in" in2="o" />
					<feComposite in="SourceGraphic" />
				</filter>
			</defs>
			<g>
				<g transform="translate(492.612 -126.28)">
					<rect
						className="b-way-submenu"
						width={1427.387}
						height={206.155}
						transform="translate(0 126.409)"
					/>
					<g transform="translate(0 126.409)">
						<g className="c-way-submenu">
							<path
								className="d-way-submenu"
								d="M1189.053,402.13l-.541-.21,41.367-92.276a55.308,55.308,0,0,1,21.556-24.336,61.508,61.508,0,0,1,32.454-9.135h184.873v.544H1283.888c-23.457,0-44.444,13.007-53.468,33.136Z"
								transform="translate(-5.245 -137.554)"
							/>
							<path
								className="d-way-submenu"
								d="M369.429,0l.638.247L321.252,109.14a65.276,65.276,0,0,1-25.436,28.719,72.593,72.593,0,0,1-38.3,10.779H39.353V148H257.516c27.681,0,52.448-15.349,63.1-39.1Z"
								transform="translate(-0.174 -117.002)"
							/>
							<path
								className="e-way-submenu"
								d="M1442.394,155.049,1386.479,279.8c-9.024,20.13-30.01,33.136-53.468,33.136h-28.562v0H1169.46A61.52,61.52,0,0,0,1137,322.063a55.312,55.312,0,0,0-21.555,24.336L581.086,471.147l.541.21L1115.99,346.61c9.025-20.13,30.012-33.136,53.47-33.136h28.562v0h134.99a61.522,61.522,0,0,0,32.455-9.135,55.319,55.319,0,0,0,21.556-24.336l55.913-124.748Z"
								transform="translate(-2.564 -128.54)"
							/>
						</g>
					</g>
				</g>
				<path
					className="b-way-submenu"
					d="M367.709,339.246H0V0H586.714l-62.14,206.671a173.939,173.939,0,0,1-15.633,36.562c-36.385,63.36-89.124,96.013-141.232,96.013"
					transform="translate(0 0.129)"
				/>
				<g transform="translate(0 -103.871)">
					<path
						className="f-way-submenu"
						d="M68.406,0,0,197.973H317.907L386.312,0Z"
						transform="translate(530.617 103.871)"
					/>
					<path
						className="g-way-submenu"
						d="M68.406,0,0,197.973H317.907L386.312,0Z"
						transform="translate(530.617 103.871)"
					/>
					<text
						className="h-way-submenu"
						transform="translate(562 268)">
						<tspan x={22.896} y={24}>
							{'Nuestra Historia'}
						</tspan>
					</text>
					<path
						className="i-way-submenu"
						d="M396.733,0,328.326,197.973H646.233L714.64,0Z"
						transform="translate(524.455 103.871)"
					/>
					<path
						className="g-way-submenu"
						d="M396.733,0,328.326,197.973H646.233L714.64,0Z"
						transform="translate(524.455 103.871)"
					/>
					<text
						className="h-way-submenu"
						transform="translate(886 268)">
						<tspan x={72.516} y={24}>
							{'Filosof\xEDa'}
						</tspan>
					</text>
					<path
						className="j-way-submenu"
						d="M725.059,0,656.652,197.973H974.56L1042.966,0Z"
						transform="translate(518.294 103.871)"
					/>
					<path
						className="g-way-submenu"
						d="M725.059,0,656.652,197.973H974.56L1042.966,0Z"
						transform="translate(518.294 103.871)"
					/>
					<text
						className="h-way-submenu"
						transform="translate(1210 268)">
						<tspan x={19.848} y={24}>
							{'rECONOCIMIENTOS'}
						</tspan>
					</text>
					<path
						className="k-way-submenu"
						d="M1053.385,0,984.98,197.973h317.907L1371.292,0Z"
						transform="translate(512.132 103.871)"
					/>
					<path
						className="g-way-submenu"
						d="M1053.385,0,984.98,197.973h317.907L1371.292,0Z"
						transform="translate(512.132 103.871)"
					/>
					<text
						className="h-way-submenu"
						transform="translate(1533 268)">
						<tspan x={111.696} y={24}>
							{'rse'}
						</tspan>
					</text>
					<g
						className="p-way-submenu"
						transform="matrix(1, 0, 0, 1, -9, 98)">
						<path
							className="l-way-submenu"
							d="M366,457.568H0V126.409H579.611L519,328.153a169.849,169.849,0,0,1-15.248,35.69C468.267,425.694,416.828,457.568,366,457.568"
							transform="translate(9 -120.41)"
						/>
					</g>
					<g
						className="o-way-submenu"
						transform="matrix(1, 0, 0, 1, -9, 98)">
						<path
							className="m-way-submenu"
							d="M366,457.568H0V126.409H579.611L519,328.153a169.849,169.849,0,0,1-15.248,35.69C468.267,425.694,416.828,457.568,366,457.568"
							transform="translate(9 -120.41)"
						/>
					</g>
					<text
						className="n-way-submenu"
						transform="translate(281 396)">
						<tspan x={-141.162} y={0}>
							{'tRAYECTORIA'}
						</tspan>
					</text>
				</g>
			</g>
		</svg>
	)
}

export default SubmenuWay
